export default __webpack_public_path__ + "static/media/1013.4ef71065.svg";